import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DashboardComponent } from './dashboard.component';
import { DashboardRoutingModule } from 'src/app/main/dashboard/dashboard-routing.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { OurServicesModule } from 'src/app/main/service/our-services/our-services.module';
import { EnterpriseDashboardComponent } from './enterprise-dashboard/enterprise-dashboard.component';
import { MyServicesModule } from '../service/my-services/my-services.module';
import { IconsModule } from '../../icons/icons.module';
import { CircleProgressBarModule } from '../../components/circle-progress-bar/circle-progress-bar.module';
import { TicketsModule } from '../../components/tickets/tickets.module';
import { ByobDashboardComponent } from './byob-dashboard/byob-dashboard.component';
import { ByobMyServicesModule } from 'src/app/components/byob-my-services/byob-my-services.module';
import { MatDividerModule } from '@angular/material/divider';
import { LearnSaasModule } from 'src/app/components/learn-saas/learn-saas.module';
import { MeteringResourcesDialogModule } from 'src/app/components/metering-resources-dialog/metering-resources-dialog.module';
import * as echarts from 'echarts';
import { NgxEchartsModule } from 'ngx-echarts';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';


@NgModule({
  declarations: [
    DashboardComponent,
    EnterpriseDashboardComponent,
    ByobDashboardComponent
  ],
  imports: [
    CommonModule,
    SharedModule,

    DashboardRoutingModule,
    OurServicesModule,
    MyServicesModule,
    IconsModule,
    CircleProgressBarModule,
    TicketsModule,
    MatDividerModule,
    ByobMyServicesModule,
    LearnSaasModule,
    NgxSkeletonLoaderModule,
    NgxEchartsModule.forRoot({
      echarts
    }),
    MeteringResourcesDialogModule
  ]
})
export class DashboardModule { }
